import React, { Fragment } from 'react';
import { CitationSource } from 'annotator/annotator-types';

type CitationProps = { source: number }

const Citation: React.FC<CitationProps> = ({ source }) => {
  const { Annotator } = window;
  const retrievedSource: CitationSource = Annotator.data.citationSources[source];

  return (
    <Fragment>
      {(retrievedSource && retrievedSource.type === 'www') && (
        <a target="_blank" rel="noopener noreferrer" title={retrievedSource.url} href={retrievedSource.url}>
          {retrievedSource.url}
        </a>
      )}
    </Fragment>
  );
};

export default Citation;
